export type NotificationChipCounts = {
  all: number;
  messages: number;
  pickups: number;
};

/**
 * Chip / badge counts: messages plus unread pickup alerts (not collapsed summary cards).
 */
export const getNotificationChipCounts = (
  messageCount: number,
  pickupCardCount: number
): NotificationChipCounts => ({
  all: messageCount + pickupCardCount,
  messages: messageCount,
  pickups: pickupCardCount,
});
